var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-section',{staticClass:"rr-scatter-section",attrs:{"title":"心率间隔散点图"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"chart-container"},[_c('div',{staticClass:"scatter-chart",attrs:{"id":_vm.chartId}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }